import PropTypes from "prop-types";
import { roleModuleAction } from './constants';

const ShowForRoleComponent = (props) => {
    let show = false;
    let rolActions = roleModuleAction.find((rol) => { return rol.Rol === Number(props.rol) });
    if (rolActions) {
        /**
         * Si es FULL, significa que puede realizar cualquier accion
         */
        show = rolActions.Full || rolActions.Actions.includes(props.moduleAction);
    }
    return show ? props.children : null;
}

ShowForRoleComponent.prototype = {
    rol: PropTypes.number.isRequired,
    moduleAction: PropTypes.string.isRequired
}


export const ShowForRole = (ShowForRoleComponent);